/** @type {import('./$types').PageLoad} */
export async function load() {
	return {
		heading: 'This is my blog'
	};
}
